import { render } from "./GridForm.vue?vue&type=template&id=767548bd"
import script from "./GridForm.vue?vue&type=script&lang=js"
export * from "./GridForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/omniauto/omniadmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__